import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import classNames from 'classnames';
import { Image } from '@components/common';
import utils, { constants } from '@utils';

class DetailsPanel extends Component {
	shouldComponentUpdate = ({ detailsData }) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.detailsData, detailsData)
		);
	}

	renderDetailItem = (label, value, icon = null, borderRight = false) => (
		<div
			key={`details_item_${label}_${value}`}
			className={classNames('flex flex-1', { 'margin-right-10 border-right-1' : borderRight, 'margin-bottom-20' : !icon })}
		>
			<If condition={icon}>
				<i className={`${icon} font-size-20 color-gray-regent margin-right-10 padding-top-10`} />
			</If>
			<div className="flex-2 flex flex-direction-column">
				<span className="font-size-12 font-regular color-gray-regent">{ label }</span>
				<span className="font-size-16 font-regular color-gray-oxford">{ value }</span>
			</div>
		</div>
	)

	render() {
		const { detailsData } = this.props;

		const {
			OrganizationLogo,
			Name,
			OrganizationTypeId,
			JurisdictionName,
			PrimaryContactCity,
			PrimaryContactState,
			PrimaryContactEmail,
			PrimaryContactJurisdiction,
			PrimaryContactPhoneNumber,
			PrimaryContactRank,
			AverageOfficerRate,
			Biography,
			TotalJobCount,
			TotalLocationCount,
		} = detailsData;

		const isAgency = OrganizationTypeId === constants.ORGANIZATION_TYPE.LAW_ENFORCEMENT_DEPARTMENT;

		return (
			<div className="bg-white padding-20">
				<div className="flex-center flex-direction-column padding-top-10 padding-bottom-10">
					<Image
						className="height-90 width-90 border-radius-circle margin-bottom-10 img-cover"
						src={OrganizationLogo || ''}
						fallbackSrc="avatar"
					/>
					<span className="font-size-24 font-regular color-gray-oxford">{ Name }</span>
					<span className="font-size-14 font-regular color-gray-regent">
						{ isAgency ? 'Agency' : 'Coordinator'}
						{' '}
						|
						{' '}
						{PrimaryContactCity}
						,
						{' '}
						{PrimaryContactState}
					</span>
				</div>
				<div className="separator" />
				<div className="flex flex-align-items-center">
					{ this.renderDetailItem('Avg. Officer Rate', utils.currencyFormatter(AverageOfficerRate || 0), 'rkf rkf-dollar-circle') }
				</div>
				<div className="separator" />
				<div className="flex">
					<div className="flex-1">
						<a
							href={`mailto:${PrimaryContactEmail}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							<i className="rkf rkf-email font-size-20 text-primary vertical-align-middle margin-right-10" />
							<span className="font-size-16 font-regular text-primary">Email</span>
						</a>
					</div>
					<div className="flex-1">
						<a
							href={`tel:${PrimaryContactPhoneNumber}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							<i className="rkf rkf-phone font-size-20 text-primary vertical-align-middle margin-right-10" />
							<span className="font-size-16 font-regular text-primary">Phone</span>
						</a>
					</div>
				</div>
				<div className="separator" />
				<div className="flex">
					{ this.renderDetailItem('Total Jobs', TotalJobCount) }
					{ this.renderDetailItem('Total Locations', TotalLocationCount) }
				</div>
				{ this.renderDetailItem('Department', isAgency ? JurisdictionName : PrimaryContactJurisdiction) }
				<If condition={!isAgency}>
					{ this.renderDetailItem('Rank', PrimaryContactRank) }
					{ this.renderDetailItem('Bio', Biography) }
				</If>
			</div>
		);
	}
}

const mapStateToProps = ({
	coordinators : {
		details : { data : detailsData },
	},
}) => ({
	detailsData,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
});

DetailsPanel.propTypes = {
	detailsData : PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsPanel);
